import type { AppRouteMatch } from 'components/App/Routes/routeTypes'

export type DestinationProductDotRouteParams = {
  location?: string
  holidayType?: string
  productType: string
  locationOrHolidayType?: string
  country?: string
  state?: string
  city?: string
}

/**
 * React Router `matchPath` cannot parse dotted destination-product segments
 * (`location.holidayType.productType`). Mirror the client route matcher so SSR
 * prefetch and redirects receive the same params.
 */
export function matchDestinationProductDotRoute(
  pathname: string,
): AppRouteMatch<DestinationProductDotRouteParams> | null {
  const matched = /^\/([^/]+)\/([^/.]+)(?:\.([^/.]+))?\.([^/.]+)$/.exec(pathname)

  if (matched) {
    const [, , firstSegment, secondSegment, productType] = matched
    const params = secondSegment ? {
      location: decodeURIComponent(firstSegment),
      holidayType: decodeURIComponent(secondSegment),
      productType: decodeURIComponent(productType),
    } : {
      locationOrHolidayType: decodeURIComponent(firstSegment),
      productType: decodeURIComponent(productType),
    }

    return {
      isExact: true,
      params,
      path: secondSegment ? '/:regionCode/:location.:holidayType.:productType' : '/:regionCode/:locationOrHolidayType.:productType',
      url: pathname,
    }
  }

  const regionlessMatched = /^\/([^/.]+)(?:\.([^/.]+))?\.([^/.]+)$/.exec(pathname)

  if (!regionlessMatched) {
    return null
  }

  const [, firstSegment, secondSegment, productType] = regionlessMatched
  const params = secondSegment ? {
    location: decodeURIComponent(firstSegment),
    holidayType: decodeURIComponent(secondSegment),
    productType: decodeURIComponent(productType),
  } : {
    locationOrHolidayType: decodeURIComponent(firstSegment),
    productType: decodeURIComponent(productType),
  }

  return {
    isExact: true,
    params,
    path: secondSegment ? '/:location.:holidayType.:productType' : '/:locationOrHolidayType.:productType',
    url: pathname,
  }
}
